import { defineMessages } from 'react-intl';

export const joinMessages = defineMessages({
    'join.available.rewards': {
        id: 'join.available.rewards',
        defaultMessage: 'Available Rewards',
        description:
            'Section title for the available rewards in the join dialog',
    },
    'join.title': {
        id: 'join.title',
        defaultMessage: 'Finish the program, unlock your reward.',
        description: 'Title for the reward-based join dialog',
    },
    'join.subtitle': {
        id: 'join.subtitle',
        defaultMessage:
            'Your progress starts now. Once you complete every session in the program, we’ll send you a unique code to unlock the reward of your choice.',
        description: 'Subtitle for the reward-based join dialog',
    },
});

export default joinMessages;
